import { Button, Checkbox, Flex, Tooltip } from 'antd'
import RemoveIcon from 'shared/icons/remove-icon.svg?react'
import { FormattedMessage } from 'react-intl'
import { ImageControls } from '../ChooseImageModal/types'
import DefaultIcon from './default.svg?react'
import RemoveDefaultIcon from './undefault.svg?react'
import s from './s.module.css'
import { ImageProp } from './types'
import { lang } from '@/components/Masonry/lang.ts'

interface Props<T extends ImageProp> {
  controls: ImageControls<T>
  hasHoverControls?: boolean
  img: T
  showCheckbox?: boolean
  isSelected?: boolean
}

function Controls<T extends ImageProp>({ hasHoverControls, controls, img, isSelected, showCheckbox }: Props<T>) {
  return (
    <>
      {hasHoverControls ? (
        <Flex className={s.hoverControls} gap={8} align="center" justify="center">
          {controls.onSetDefault ? (
            <Tooltip
              destroyTooltipOnHide
              title={
                <div className={s.tooltip}>
                  <FormattedMessage {...lang.flag} />
                </div>
              }
            >
              <Button onClick={() => controls.onSetDefault?.(img)} icon={<DefaultIcon />} />
            </Tooltip>
          ) : null}
          {controls.onUnsetDefault ? (
            <Tooltip
              destroyTooltipOnHide
              title={
                <div className={s.tooltip}>
                  <FormattedMessage {...lang.removeFlag} />
                </div>
              }
            >
              <Button onClick={controls.onUnsetDefault} icon={<RemoveDefaultIcon />} />
            </Tooltip>
          ) : null}
          {controls.onRemove ? <Button onClick={() => controls.onRemove?.([img])} icon={<RemoveIcon />} /> : null}
        </Flex>
      ) : null}
      {showCheckbox ? <Checkbox className={s.selectCheckbox} checked={isSelected} /> : null}
    </>
  )
}

export default Controls
